import { Capacitor } from '@capacitor/core'
import NativeBiometricAuthService, { hasNativePlugin } from './NativeBiometricAuthService'

const UNSUPPORTED = {
  isAvailable: async () => ({ available: false, type: null, notEnrolled: false, lockedOut: false }),
  hasVault: async () => false,
  getVaultStatus: async () => ({ enrolled: false, email: null }),
  enroll: async () => {
    throw new Error('Biometric login is not supported on this platform')
  },
  authenticate: async () => {
    throw new Error('Biometric login is not supported on this platform')
  },
  clear: async () => {},
}

/**
 * Biometric login is enabled on the native (Capacitor) apps only.
 *
 * Both iOS and Android are Capacitor apps, so they share one implementation:
 * Face ID/Touch ID via LocalAuthentication and BiometricPrompt respectively,
 * with the credential vault in the iOS Keychain / Android Keystore. Plain web
 * (desktop or mobile browser) gets the UNSUPPORTED stub, so the option is never
 * offered outside the apps - a browser could otherwise expose Windows Hello or
 * Touch ID through WebAuthn, which is not hardware-bound to this app.
 */
// Native is NOT the same question as "does this binary carry the plugins".
// Older shells (iOS 1.4.4 build 83/84) ship this JS but none of the native
// plugins, and SecureStorage there recurses into itself through promise
// continuations - an infinite microtask loop that starves every timer and hangs
// the app on the login screen. See nativePlugins.js for why PluginHeaders is the
// only reliable check.
const hasNativeVault = hasNativePlugin('SecureStorage') &&
  hasNativePlugin('BiometricAuthNative')

const backend = Capacitor.isNativePlatform() && hasNativeVault
  ? NativeBiometricAuthService
  : UNSUPPORTED

const BiometricAuthService = {
  isAvailable: (...args) => backend.isAvailable(...args),
  hasVault: (...args) => backend.hasVault(...args),
  getVaultStatus: (...args) => backend.getVaultStatus(...args),
  enroll: (...args) => backend.enroll(...args),
  authenticate: (...args) => backend.authenticate(...args),
  clear: (...args) => backend.clear(...args),
}

export default BiometricAuthService
